import { useAbandonCheckoutMutation, useCheckoutToken, useIsAppleRetailOrder } from '../../state'

export const useCallAbandonCheckout = (): (() => Promise<void>) => {
  const [abandonCheckout] = useAbandonCheckoutMutation()
  const checkoutToken = useCheckoutToken()
  const isAppleRetailOrder = useIsAppleRetailOrder()

  return async (): Promise<void> => {
    if (isAppleRetailOrder) {
      try {
        await abandonCheckout({ token: checkoutToken }).unwrap()
      } catch {
        // ignore error
      }
    }
  }
}
